import { FC, Fragment, MouseEvent, useCallback, useState } from "react";
import {
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  PopoverOrigin,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { CommitmentsUtilizationGrouping } from "@/services/cloudchipr.api";

import { commitmentGroupByTitleByGrouping } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/utils/constants/constants";

interface CommitmentUtilizationWidgetGroupBySelectProps {
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  grouping: CommitmentsUtilizationGrouping;
  onChange(grouping: CommitmentsUtilizationGrouping): void;
  CustomTriggerComponent?: FC<{ onClick: (event: any) => void }>;
}

export const CommitmentUtilizationWidgetGroupBySelect: FC<
  CommitmentUtilizationWidgetGroupBySelectProps
> = ({
  grouping,
  onChange,
  CustomTriggerComponent,
  transformOrigin,
  anchorOrigin,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = useCallback(
    (newGrouping: CommitmentsUtilizationGrouping) => {
      if (newGrouping === grouping) {
        return;
      }

      onChange(newGrouping);
      handleClose();
    },
    [grouping, onChange],
  );

  const getHandleSelect = useCallback(
    (newGrouping: CommitmentsUtilizationGrouping) => {
      return () => handleSelect(newGrouping);
    },
    [handleSelect],
  );

  const handleChange = useCallback(
    (event: SelectChangeEvent<CommitmentsUtilizationGrouping>) => {
      handleSelect(event.target.value as CommitmentsUtilizationGrouping);
    },
    [handleSelect],
  );

  if (CustomTriggerComponent) {
    return (
      <Fragment>
        <CustomTriggerComponent onClick={handleOpen} />

        <Menu
          open={menuOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          onChange={handleChange as any}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <MenuItem
            value="commitment_type"
            onClick={getHandleSelect("commitment_type")}
          >
            {commitmentGroupByTitleByGrouping.get("commitment_type")}
          </MenuItem>
          <MenuItem value="id" onClick={getHandleSelect("id")}>
            {commitmentGroupByTitleByGrouping.get("id")}
          </MenuItem>
          <MenuItem value="ungrouped" onClick={getHandleSelect("ungrouped")}>
            {commitmentGroupByTitleByGrouping.get("ungrouped")}
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Group By</InputLabel>

      <Select value={grouping} onChange={handleChange} label="Group By">
        <MenuItem value="commitment_type">
          {commitmentGroupByTitleByGrouping.get("commitment_type")}
        </MenuItem>
        <MenuItem value="id">
          {commitmentGroupByTitleByGrouping.get("id")}
        </MenuItem>
        <MenuItem value="ungrouped">
          {commitmentGroupByTitleByGrouping.get("ungrouped")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
